<template>
	<div class="modal-wrapper">
		<div class="accessory-container bg-white">
			<div class="flex justify-end pt-20 pr-20">
				<button class="modal-btn" @click="onClose" v-text="'X'" />
			</div>
			<div class="modal-text mt-10 ml-20">
				<div class="modal-title small-text font-medium mb-10">
					{{ $tc('modals.wizardSubscription.title') }}
				</div>
				<div class="modal-body small-sm-text mr-50" v-html="$tc('modals.wizardSubscription.mainText')" />
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalWizardSubscription',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
	.accessory-container {
		width: 544px;
		min-height: 250px;
		border: #EEEEEE solid 6px;

		.modal-row {
			@include respond-below(phone) {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
			}
		}
	}
</style>
